import { render, staticRenderFns } from "./order-acknowledgment.vue?vue&type=template&id=3466d26a&"
import script from "./order-acknowledgment.vue?vue&type=script&lang=js&"
export * from "./order-acknowledgment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports